import background from "galaxies/orange-galaxy/orange-background.svg"
import satellite from "galaxies/elements/orange-satellite.svg"
import gameControl from "galaxies/elements/orange-game-control.svg"
import milkyWay from "galaxies/elements/purple-milky-way.svg"

export default {
  background: background,
  satellite: satellite,
  gameControl: gameControl,
  milkyWay: milkyWay
}
